import { jsx } from "react/jsx-runtime";
import { forwardRef, useEffect } from "react";
import { useBreakpoint } from "../../hooks/useBreakpoint.js";
import "@mui/material";
import { DATA_TEST_ID_INHERITED } from "../../constants/DATA_TEST_ID_INHERITED.js";
import Slide from "../../external/@mui/material/Slide/Slide.js";
import Dialog from "../../external/@mui/material/Dialog/Dialog.js";
const Transition = forwardRef(function(props, ref) {
  return /* @__PURE__ */ jsx(Slide, { direction: "up", ref, ...props });
}), MobileBottomSheet = ({
  open,
  onClose,
  onClick,
  children,
  ...props
}) => {
  const { xsOnly } = useBreakpoint("xs");
  return useEffect(() => {
    onClose();
  }, [xsOnly]), /* @__PURE__ */ jsx(
    Dialog,
    {
      "data-test-id": DATA_TEST_ID_INHERITED,
      onClick,
      keepMounted: !1,
      open,
      onClose,
      TransitionComponent: Transition,
      fullWidth: !0,
      maxWidth: "xl",
      sx: dialogSx,
      ...props,
      children
    }
  );
}, dialogSx = {
  "& .MuiDialog-container": {
    alignItems: "flex-end"
  },
  "& .MuiPaper-root": {
    width: "100%",
    maxWidth: "100%",
    margin: 0,
    overflow: "hidden"
  }
};
export {
  MobileBottomSheet,
  MobileBottomSheet as default
};
//# sourceMappingURL=MobileBottomSheet.js.map
